// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules_dev/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".definition-list{max-height:400px;overflow-y:auto}.definition-list a{display:block}", ""]);
// Exports
module.exports = exports;
